import { AssetCountersJson } from './dto';

const assetCountersJsonExample: AssetCountersJson = {
	dataflows: 11,
	endpoints: 51,
	storage_connections: 2,
};

export { assetCountersJsonExample };
